import {
  GET_LIST_PHIKHAC,
  GET_LIST_PHIKHAC_SUCCESS,
  GET_LIST_PHIKHAC_FAILURE,
  GET_LIST_PHIKHAC_CHOVAY,
  GET_LIST_PHIKHAC_CHOVAY_SUCCESS,
  GET_LIST_PHIKHAC_CHOVAY_FAILURE,
} from "./actionTypes";

export const getListPhiKhac = (dataSearch) => ({
  type: GET_LIST_PHIKHAC,
  dataSearch,
});

export const getListPhiKhacSuccess = (data) => ({
  type: GET_LIST_PHIKHAC_SUCCESS,
  payload: data,
});

export const getListPhiKhacFailure = () => ({
  type: GET_LIST_PHIKHAC_FAILURE,
});

export const getListPhiKhacTheoChoVay = (dataSearch) => ({
  type: GET_LIST_PHIKHAC_CHOVAY,
  dataSearch,
});

export const getListPhiKhacTheoChoVaySuccess = (data) => ({
  type: GET_LIST_PHIKHAC_CHOVAY_SUCCESS,
  payload: data,
});

export const getListPhiKhacTheoChoVayFailure = () => ({
  type: GET_LIST_PHIKHAC_CHOVAY_FAILURE,
});
